module.exports = __webpack_public_path__ + "static/media/back stage photo shoot .2aa265d3.jpg";